module.exports = __webpack_public_path__ + "img/restaurant-8.372abab3.jpg";